import { useSystemColorScheme } from '@src/hooks/useSystemColorScheme';
import type { RootState } from '@src/store';
import { darkTheme, focusModeTheme, theme } from '@src/theme';
import { useSelector } from 'react-redux';

/**
 * アプリケーションのテーマを取得するフック
 * フォーカスモード、カラーモード設定、システム設定に基づいて適切なテーマを返す
 * @returns 現在のテーマ
 */
export function useTheme() {
  const isFocusMode = useSelector((state: RootState) => state.focusMode.isFocusMode);
  const colorMode = useSelector((state: RootState) => state.focusMode.colorMode);
  const systemColorScheme = useSystemColorScheme();

  if (isFocusMode) {
    return focusModeTheme;
  }

  if (colorMode === 'dark') {
    return darkTheme;
  }

  if (colorMode === 'light') {
    return theme;
  }

  // system
  return systemColorScheme === 'dark' ? darkTheme : theme;
}
